import OutletWithDefaultElectionContext from './OutletWithDefaultElectionContext';
import RegionAccessCode from './RegionAccessCode';
import { SummaryTypeProvider } from '../contexts/SummaryTypeContext';

function ContextWrapper() {
    return (
        <RegionAccessCode>
            <SummaryTypeProvider>
                <OutletWithDefaultElectionContext />
            </SummaryTypeProvider>
        </RegionAccessCode>
    );
}

export default ContextWrapper;
